// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PZzpX","badges":"styles_badges__5hC_9"};